import { define } from './define';

// Deactivating members, scheduling after approval (a piece made for a slot, free slots, the agent),
// prizes from a piece, and the brand's variant styles. Spanish first; English must have the same keys (TypeScript checks it).
export const features = define({
  es: {
    // Members: deactivating and reactivating.
    'members.deactivate': 'Desactivar',
    'members.reactivate': 'Reactivar',
    'members.deactivateTitle': '¿Desactivar a {name}?',
    'members.deactivateText': 'No podrá abrir esta marca ni recibirá avisos de ella hasta que la reactives. Lo que hizo conserva su nombre.',
    'members.deactivateTokens': 'Los tokens de API que creó en esta marca se revocan, y siguen revocados aunque la reactives.',
    'members.deactivatedToast': { zero: 'Persona desactivada', one: 'Persona desactivada · {count} token revocado', other: 'Persona desactivada · {count} tokens revocados' },
    'members.reactivateTitle': '¿Reactivar a {name}?',
    'members.reactivateText': 'Vuelve a entrar con su rol de {role}. Los tokens que se revocaron al desactivarla siguen revocados: crea otros si hacen falta.',
    'members.reactivatedToast': 'Persona reactivada',
    'members.deactivatedSection': 'Desactivados',
    'members.deactivatedBy': 'Desactivado por {who} el {date}',
    'members.deactivatedOn': 'Desactivado el {date}',
    'members.cannotSelf': 'No puedes desactivarte a ti mismo: pídeselo a otro administrador.',
    'members.lastAdmin': 'Es el único administrador activo de la marca: haz administrador a otra persona antes.',

    // A person deactivated in a brand.
    'deactivated.title': 'Te han desactivado en {brand}',
    'deactivated.text': 'No puedes abrir esta marca hasta que un administrador te reactive.',
    'deactivated.since': 'Desde el {date}.',
    'deactivated.noBrands': 'No tienes ninguna marca activa',
    'deactivated.where': 'Te han desactivado en {brands}. Pide a un administrador que te reactive.',
    'deactivated.switcher': 'Te han desactivado en',
    'deactivated.banner': 'Te han desactivado en {brand}: no puedes abrirla hasta que un administrador te reactive.',

    // The bell.
    'notif.kind.publication.auto_scheduled': 'Postbay ha programado algo aprobado',
    'notif.kind.publication.handed_over': 'Una publicación ha pasado a hacerse a mano',
    'notif.kind.agent.timed_out': 'Una ejecución del agente se ha quedado sin tiempo',

    // The agent's runs.
    'outcome.scheduled': 'Programó lo aprobado',
    'trigger.version.approved': 'Versión aprobada',

    // Settings: the brand's rules and the agent.
    'fx.rules.autoFill': 'Rellenar huecos libres con lo aprobado',
    'fx.rules.autoFillHint': 'Lo aprobado que nadie ha programado va al siguiente hueco libre de una cuenta para la que se aprobó.',
    'fx.rules.autoFillSince': 'Activo desde el {date}. Solo toma lo aprobado desde entonces.',
    'fx.rules.styles': 'Estilos de variante',
    'fx.rules.stylesHint': 'Uno por línea, en el orden en que se eligen. El agente usa estos.',
    'fx.rules.stylesPlaceholder': 'Riso\nCollage\nFotografía de producto',
    'fx.agent.canSchedule': 'El agente puede programar lo aprobado',
    'fx.agent.canScheduleHint': 'Solo en las cuentas para las que se aprobó. Nunca aprueba, ni cancela ni mueve nada.',

    // A variant's style.
    'fx.styles.noStyle': 'Sin estilo',
    'fx.styles.notInList': '{style} · no está en la lista',
    'fx.styles.none': 'La marca no tiene estilos',
    'fx.styles.define': 'Definirlos en Ajustes',

    // Who scheduled a post, and the slot a piece was made for.
    'fx.by.auto': 'Programada por Postbay en un hueco libre',
    'fx.by.autoShort': 'Postbay',
    'fx.by.agent': 'Programada por el agente',
    'fx.by.agentNamed': 'Programada por el agente ({name})',
    'fx.by.agentShort': 'Agente',
    'fx.slot.field': 'Hueco',
    'fx.slot.removed': 'Hueco eliminado',
    'fx.slot.unnamed': 'Hueco',
    'fx.slot.inactive': 'desactivado',
    'fx.slot.create': 'Crear pieza para este hueco',
    'fx.slot.createShort': 'Crear pieza',
    'fx.slot.for': 'Para el hueco',

    // Approving: scheduling it by itself.
    'fx.approve.atSlot': 'Programar al aprobar',
    'fx.approve.nextFree': 'Programar en el siguiente hueco libre',
    'fx.approve.nextFreeHint': 'La marca rellena sus huecos libres con lo aprobado: irá al primero de una cuenta para la que la apruebes.',
    'fx.approve.wontSchedule': 'No se programará al aprobar.',
    'fx.approve.needsAccount': 'Apruébala también para {account}, la cuenta del hueco, o no se programará.',
    'fx.approve.text': 'Texto de la publicación',
    'fx.approve.firstComment': 'Primer comentario',
    'fx.approve.scheduled': 'Aprobada y programada',
    'fx.approve.notScheduled': 'Aprobada, sin programar',
    'fx.approve.counted': 'Tu aprobación cuenta',
    'fx.approve.seeCalendar': 'Ver en el calendario',

    // Prizes from a piece of the studio.
    'fx.prizes.kindPiece': 'Pieza del estudio',
    'fx.prizes.addPiece': 'Pieza del estudio',
    'fx.prizes.piece': 'Pieza',
    'fx.prizes.pieceHint': 'Se entrega el archivo principal de su última versión aprobada en el momento de la descarga.',
    'fx.prizes.choosePiece': 'Elige una pieza',
    'fx.prizes.noPieces': 'No hay piezas todavía',
    'fx.prizes.notApprovedYet': 'sin aprobar',
    'fx.prizes.handsOut': 'v{n} · {file} · aprobada el {date}',
    'fx.prizes.noApproved': 'Sin versión aprobada',
    'fx.prizes.unavailable': 'No disponible',
    'prizes.public.error.no_approved_version': 'Este premio no está disponible ahora mismo. Vuelve a intentarlo más tarde.',
  },
  en: {
    'members.deactivate': 'Deactivate',
    'members.reactivate': 'Reactivate',
    'members.deactivateTitle': 'Deactivate {name}?',
    'members.deactivateText': 'They will not be able to open this brand or be told anything about it until you reactivate them. What they did keeps their name.',
    'members.deactivateTokens': 'The API tokens they made in this brand are revoked, and stay revoked if you reactivate them.',
    'members.deactivatedToast': { zero: 'Person deactivated', one: 'Person deactivated · {count} token revoked', other: 'Person deactivated · {count} tokens revoked' },
    'members.reactivateTitle': 'Reactivate {name}?',
    'members.reactivateText': 'They come back as {role}. The tokens revoked when they were deactivated stay revoked: make new ones if needed.',
    'members.reactivatedToast': 'Person reactivated',
    'members.deactivatedSection': 'Deactivated',
    'members.deactivatedBy': 'Deactivated by {who} on {date}',
    'members.deactivatedOn': 'Deactivated on {date}',
    'members.cannotSelf': 'You cannot deactivate yourself: ask another admin to.',
    'members.lastAdmin': 'They are the brand’s only active admin: make someone else an admin first.',

    'deactivated.title': 'You were deactivated in {brand}',
    'deactivated.text': 'You cannot open this brand until an admin reactivates you.',
    'deactivated.since': 'Since {date}.',
    'deactivated.noBrands': 'You have no active brand',
    'deactivated.where': 'You were deactivated in {brands}. Ask an admin to reactivate you.',
    'deactivated.switcher': 'Deactivated in',
    'deactivated.banner': 'You were deactivated in {brand}: you cannot open it until an admin reactivates you.',

    'notif.kind.publication.auto_scheduled': 'Postbay scheduled something approved',
    'notif.kind.publication.handed_over': 'A post was handed over to be published by hand',
    'notif.kind.agent.timed_out': 'An agent run ran out of time',

    'outcome.scheduled': 'Scheduled what was approved',
    'trigger.version.approved': 'Version approved',

    'fx.rules.autoFill': 'Fill free slots with what is approved',
    'fx.rules.autoFillHint': 'What is approved and nobody scheduled goes into the next free slot of an account it was approved for.',
    'fx.rules.autoFillSince': 'On since {date}. Only takes what was approved since then.',
    'fx.rules.styles': 'Variant styles',
    'fx.rules.stylesHint': 'One per line, in the order people pick from. The agent uses these.',
    'fx.rules.stylesPlaceholder': 'Riso\nCollage\nProduct photography',
    'fx.agent.canSchedule': 'The agent can schedule what is approved',
    'fx.agent.canScheduleHint': 'Only on the accounts it was approved for. It never approves, cancels or moves anything.',

    'fx.styles.noStyle': 'No style',
    'fx.styles.notInList': '{style} · not in the list',
    'fx.styles.none': 'The brand has no styles',
    'fx.styles.define': 'Set them in Settings',

    'fx.by.auto': 'Scheduled by Postbay in a free slot',
    'fx.by.autoShort': 'Postbay',
    'fx.by.agent': 'Scheduled by the agent',
    'fx.by.agentNamed': 'Scheduled by the agent ({name})',
    'fx.by.agentShort': 'Agent',
    'fx.slot.field': 'Slot',
    'fx.slot.removed': 'Slot removed',
    'fx.slot.unnamed': 'Slot',
    'fx.slot.inactive': 'switched off',
    'fx.slot.create': 'Create a piece for this slot',
    'fx.slot.createShort': 'Create piece',
    'fx.slot.for': 'For the slot',

    'fx.approve.atSlot': 'Schedule on approval',
    'fx.approve.nextFree': 'Schedule in the next free slot',
    'fx.approve.nextFreeHint': 'This brand fills its free slots with what is approved: it goes into the first one of an account you approve it for.',
    'fx.approve.wontSchedule': 'It will not be scheduled on approval.',
    'fx.approve.needsAccount': 'Approve it for {account} too, the slot’s account, or it will not be scheduled.',
    'fx.approve.text': 'Post text',
    'fx.approve.firstComment': 'First comment',
    'fx.approve.scheduled': 'Approved and scheduled',
    'fx.approve.notScheduled': 'Approved, not scheduled',
    'fx.approve.counted': 'Your approval counts',
    'fx.approve.seeCalendar': 'See it in the calendar',

    'fx.prizes.kindPiece': 'Studio piece',
    'fx.prizes.addPiece': 'Studio piece',
    'fx.prizes.piece': 'Piece',
    'fx.prizes.pieceHint': 'Whoever downloads it gets the main file of its latest approved version at that moment.',
    'fx.prizes.choosePiece': 'Choose a piece',
    'fx.prizes.noPieces': 'No pieces yet',
    'fx.prizes.notApprovedYet': 'not approved',
    'fx.prizes.handsOut': 'v{n} · {file} · approved {date}',
    'fx.prizes.noApproved': 'No approved version',
    'fx.prizes.unavailable': 'Not available',
    'prizes.public.error.no_approved_version': 'This prize is not available right now. Try again later.',
  },
});
